import { IGetRecordResponse } from '@principle-theorem/practice-migrations/interfaces';
import {
  PatientStatus,
  type IPatient,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import {
  BaseExistingPatientDestinationEntity,
  type IExistingPatientMergeConflictSummary,
} from '../../../destination/entities/existing-patient';
import { D4WPatient, PatientSourceEntity } from '../../source/entities/patient';
import { getGender, getName, getPhone } from './patients';

export class ExistingPatientDestinationEntity extends BaseExistingPatientDestinationEntity<D4WPatient> {
  patientSourceEntity = new PatientSourceEntity();

  override sourceEntities = {
    patients: this.patientSourceEntity,
  };

  getDateOfBirth(
    sourcePatient: IGetRecordResponse<D4WPatient>
  ): string | undefined {
    return sourcePatient.data.dob ?? undefined;
  }

  filterMatchingPatients(
    sourcePatient: IGetRecordResponse<D4WPatient>,
    matchingPatients: WithRef<IPatient>[]
  ): WithRef<IPatient>[] {
    return matchingPatients.filter(
      (patient) =>
        [sourcePatient.data.firstname, sourcePatient.data.surname].every(
          (name) => patient.name.toLowerCase().includes(name.toLowerCase())
        ) && patient.status === PatientStatus.Active
    );
  }

  buildConflictSummary(
    sourcePatient: D4WPatient
  ): Omit<IExistingPatientMergeConflictSummary, 'status' | 'patientRefs'> {
    const sourcePatientId = this.patientSourceEntity
      .getSourceRecordId(sourcePatient.data)
      .toString();

    return {
      sourcePatientId,
      patientName: getName(sourcePatient.data),
      dateOfBirth: sourcePatient.data.dob ?? '',
      gender: getGender(sourcePatient.data),
      phone: getPhone(sourcePatient.data),
      email: sourcePatient.data.email ?? '',
    };
  }
}
